import { useState } from 'preact/hooks'
import { FieldLabel } from './FieldLabel'
export const FieldSelect = ({ name, required, value, label, onChange, options }) => {
  const [isFocused, setIsFocused] = useState(false)

  return (
    <div className={'flex w-full flex-col gap-2'}>
      <FieldLabel {...{ label, hasInput: !!value, required }} />
      <div
        className={`relative overflow-hidden rounded-lg border border-solid border-neutrals-tertiary-grey bg-primary-white transition-colors
        ${isFocused || !!value ? 'border-2 border-secondary-green' : 'border-neutrals-tertiary-grey'}`}
      >
        <select
          className={'min-h-12 w-full border-none px-4 read-only:cursor-default'}
          name={name}
          onChange={onChange}
          value={value}
          required={required}
          onFocus={() => {
            setIsFocused(true)
          }}
          onBlur={() => {
            setIsFocused(false)
          }}
        >
          {options.map((o) => {
            return (
              <option className={'w-full'} value={o.value}>
                {o.label}
              </option>
            )
          })}
        </select>
      </div>
    </div>
  )
}
